export const BIG_SELLER_LOGO: Record<string, string> = {
  'AI Across': '/img/product/jp/sellerLogo/AI Across.png',
  'KIRIN MOBILE': '/img/product/jp/sellerLogo/KIRIN MOBILE.png',
  Mac専門店秋葉館: '/img/product/jp/sellerLogo/Mac専門店秋葉館.svg',
  'MyWiT Japan': '/img/product/jp/sellerLogo/MyWiT Japan.png',
  PRODIG: '/img/product/jp/sellerLogo/PRODIG.png',
  RECO: '/img/product/jp/sellerLogo/RECO.svg',
  'Reuse Style': '/img/product/jp/sellerLogo/Reuse Style.svg',
  エムコム: '/img/product/jp/sellerLogo/エムコム.png',
  スマホ専門販売店モバステ:
    '/img/product/jp/sellerLogo/スマホ専門販売店モバステ.png',
  トップテレホン: '/img/product/jp/sellerLogo/トップテレホン.png',
  にこスマ: '/img/product/jp/sellerLogo/にこスマ.png',
  ハピネスネット: '/img/product/jp/sellerLogo/ハピネスネット.png',
  株式会社イオシス: '/img/product/jp/sellerLogo/株式会社イオシス.png',
  株式会社エイティーワントレード:
    '/img/product/jp/sellerLogo/株式会社エイティーワントレード.png',
  株式会社ソフマップ: '/img/product/jp/sellerLogo/株式会社ソフマップ.png',
}
